import {notify} from '~/redux/ui/slice';
import {AppDispatch} from '~/redux/root-store';
import {ValidationErrors} from '~/hooks/useInput';
import {forEach} from 'lodash';

export function useNotification(dispatch: AppDispatch) {
  const addMessage = (message: string, type: 'error' | 'success' | undefined = undefined) => {
    if (type === 'error' && !message) {
      message = 'Something went wrong!';
    }
    dispatch(notify({message, type}));
    setTimeout(() => {
      dispatch(notify({type, message: ''}));
    }, 1000);
  };

  const addValidationMessage = (errors: ValidationErrors = {}, type: 'error' | 'success' | undefined = 'error') => {
    let messages: string[] = [];

    forEach(errors as ValidationErrors, (itemMessages: string[]) => {
      messages = messages.concat(itemMessages);
    });

    const message = messages.join('\n');
    addMessage(message, type);
  };

  return {addMessage, addValidationMessage};
}
